import { render, staticRenderFns } from "./eventDetails.vue?vue&type=template&id=45c2a602&scoped=true&"
import script from "./eventDetails.vue?vue&type=script&lang=js&"
export * from "./eventDetails.vue?vue&type=script&lang=js&"
import style0 from "./eventDetails.vue?vue&type=style&index=0&id=45c2a602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2a602",
  null
  
)

component.options.__file = "eventDetails.vue"
export default component.exports